import type { QueryParamsByPath, Schemas } from '@@/api/types'

export type CustomField = Schemas['CustomField']
export type CustomFieldResponse = Schemas['CustomFieldResponse']
export type PaginatedCustomFieldList = Schemas['PaginatedCustomFieldList']

export type CustomFieldListQueryParams = QueryParamsByPath<
  'get',
  '/{provet_id}/api/custom_fields'
>

export const CustomFieldType = {
  CharField: 'CHAR_FIELD',
  IntegerField: 'INTEGER_FIELD',
  DateField: 'DATE_FIELD',
  Checkbox: 'CHECKBOX',
  JsonField: 'JSON_FIELD',
  SingleSelection: 'SINGLE_SELECTION',
  MultiSelection: 'MULTI_SELECTION',
} as const

export type CustomFieldType =
  (typeof CustomFieldType)[keyof typeof CustomFieldType]

export const ContentTypeModelName = {
  Client: 'Client',
  Patient: 'Patient',
  Consultation: 'Consultation',
} as const

export type ContentTypeModelName =
  (typeof ContentTypeModelName)[keyof typeof ContentTypeModelName]

export type CustomFieldValue =
  | string // CHAR_FIELD, DATE_FIELD (ISO date string), SINGLE_SELECTION (option ID)
  | string[] // MULTI_SELECTION (array of option IDs)
  | number // INTEGER_FIELD
  | boolean // CHECKBOX

export type CustomFieldsFormData = Record<string, CustomFieldValue>

export type CustomFieldAttributes = {
  id: string
  name: string
  label?: string
  type: NonNullable<CustomField['attributes']>['field_type']
  required: NonNullable<CustomField['attributes']>['is_required']
  hint: NonNullable<CustomField['attributes']>['help_text']
  defaultValue?: CustomFieldValue
  options?: {
    id: string
    text: string
    archived: boolean
  }[]
}

export type PairedCustomField = {
  fields: CustomFieldAttributes[]
  spanFullWidth: boolean
}
